import { DOCUMENT } from '@angular/common';
import { Injectable, inject, signal } from '@angular/core';
import { LocalStorageService } from './localStorageService';

export type Theme = 'light' | 'dark';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  private readonly document = inject(DOCUMENT);
  private readonly localStore = inject(LocalStorageService);

  currentTheme  = signal<Theme>('light');

  setTheme(theme: Theme): void {
    if (theme === 'dark') {
      this.document.body.classList.add('dark-mode');
    } else {
      this.document.body.classList.remove('dark-mode');
    }
    this.currentTheme.set(theme);
    this.localStore.theme.set(theme);
  }

  toggleTheme(): void {
    this.setTheme(this.currentTheme() === 'light' ? 'dark' : 'light');
  }

  constructor() {
    this.setTheme(this.localStore.theme());
  }

}
